<!--
 * @Author: 
 * @Date: 
 * @LastEditors: 
 * @LastEditTime: 
 * @Description: file content
 -->
<template>
  <div class="ranking">
    <div class="rank-info">
      <p>我的分数</p>
      <div class="count"><span>{{myRankNumber || 0}}</span>分</div>
    </div>
    <div class="rank-list">
      <div class="rank-tab">
        <div class="rank-tab-item" :class="type==0?'self-tab-item':''" @click="upData(0)">
          个人排行
          <div class="line" v-show="type==0"></div>
        </div>
        <div class="rank-tab-item" :class="type==1?'self-tab-item':''" @click="upData(1)">
          战队排行
          <div class="line" v-show="type==1"></div>
        </div>
        <div class="rank-tab-item" :class="type==2?'self-tab-item':''" @click="upData(2)">
          我的战队
          <div class="line" v-show="type==2"></div>
        </div>
      </div>
      <div class="rank-item" v-for="(item,index) in rank_list" :key="index">
        <div class="rank-num" v-if="index>2">{{index+1}}</div>
        <div class="rank-num" v-else>
          <img :src="imgHost + 'rank'+(index+1)+'.png'" />
        </div>
        <img class="rank-img" :src="item.headImg" alt />
        <div class="rank-name">
          {{item.nickName}}
          <template v-if="item.num">（{{item.num}}人）</template>
        </div>
        <div class="rank-help-num">{{item.count}}分</div>
        <!-- <div class="rank-help-num2">第{{item.number}}名</div> -->
      </div>
      <div class="noDate" v-if="rank_list.length==0">暂无数据</div>
    </div>
    <BaseBtnHome></BaseBtnHome>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      rank_list: [],
      team_list: [],
      pageNum: 1,
      pageTeamNum: 1,
      ranking: 0,
      score: 0,
      myTeam: [],
      type: 0,
      loading: false,
      isNoMore: true,
      isTeamNoMore: true,
      rank_item:{},
      myRankNumber: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    async upData(type) {
      let data
      if (type == 0) {
        data = await this.$httpdf.get(this.apiHost + 'bird/rank')
        
      } else if (type == 1) {
        data = await this.$httpdf.get(this.apiHost + 'bird/groupRank')
       
      } else if (type == 2) {
        data = await this.$httpdf.get(this.apiHost + 'bird/myGroupRank')
      }
      if (data.code == 0) {
        this.rank_list = data.data.ranks
        this.myRankNumber = data.data.myScore || data.data.myGroupScore
      }
      this.type = type;
    },
  },
  created() {
    this.upData(0); // 获取总排行榜
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.ranking {
  position: relative;
  height: 100vh;
  width: 100%;
  padding-bottom: 20px;
  background: #F4F4F4 url( $imgHost + 'ranking_head.png?t=9') 0 -1px / 100% no-repeat;
  box-sizing: border-box;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.rank-info {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  padding: 20px 15px 0;
  p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
  .count {
    margin-top: 20px;
    span {
      font-size: 30px;
    }
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #FFFFFF;
    line-height: 22px;
  }
}
.rank-tab {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #EAEAEA;
}

.rank-tab-item {
  font-size: 17px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  flex: 1;
  text-align: center;
  height: 43px;
  line-height: 41px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.self-tab-item {
  font-size: 17px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #3FA4FA;
}

.line {
  width: 33px;
  height: 2px;
  background:#3FA4FA;
  border-radius: 1px;
}

.rank-list {
  position: relative;
  width: 345px;
  height: calc(100vh - 120px);
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  overflow-y: auto;
}

.rank-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 58px;
  line-height: 58px;
  margin: 0 5px;
  border-bottom: 1px solid #E1E1E1;
  padding-right:8px;
}

.rank-item:last-child {
  border-bottom: none;
}

.rank-num {
  width: 20px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  text-align: center;
  margin-right: 18px;
}

.rank-num img {
  width: 16px;
  height: 23px;
}

.rank-img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.rank-name {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  flex: 1;
  padding: 0 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
} 
.rank-item2 .rank-name {
  color:  #F05867;
}

.rank-help-num {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  // width: 70px;
  text-align: right;
}

.rank-help-num2 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #F05867;
  // width: 70px;
  text-align: right;
}

.noDate {
  text-align: center;
  padding: 8px 0;
  font-size: 14px;
}

.goHome {
  position: fixed;
  bottom: 40px;
  right: 10px;
  width: 71px;
  height: 71px;
  // background: linear-gradient(180deg, rgba(28, 188, 234, 1), rgba(74, 141, 203, 1));
  // border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  text-align: justify;
  z-index: 2;
}

.goHome img {
  width: 100%;
}
</style>